import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico_Home",
  "use": "ico_Home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"ico_Home\">\n    <path data-name=\"Union 1\" d=\"M588.307 646.634h-13v-10h1v9h12v-9h1v10zm-6-16.367-8.693 6.762-.614-.789 9.307-7.24 6 4.666v-4.032h1v4.809l2.308 1.795-.614.789z\" transform=\"translate(-570.307 -625.633)\" style=\"stroke:transparent;stroke-miterlimit:10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol